import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const standingsHeader = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  "@media": {
    [`screen and (min-width: ${breakpoints[1]})`]: {
      flexDirection: "row",
      alignItems: "center",
    },
  },
});

export const pageTitleWrapper = style({
  marginBottom: vars.space.m,
});

export const headerButtonsWrapper = style({
  display: "flex",
  gap: vars.space.xs,
  "@media": {
    [`screen and (min-width: ${breakpoints[1]})`]: {
      marginInlineStart: "auto",
    },
  },
});

export const reportButtonWrapper = styleVariants({
  mobile: [
    {
      "@media": {
        [`screen and (min-width: ${breakpoints[1]})`]: {
          display: "none",
        },
      },
    },
  ],
  desktop: [
    {
      display: "none",
      "@media": {
        [`screen and (min-width: ${breakpoints[1]})`]: {
          display: "inline-block",
          marginInlineStart: vars.space.xs,
        },
      },
    },
  ],
});

export const standingsHeadingLink = style({
  marginTop: vars.space.s,
  fontSize: vars.fontSizes.body.s,
  "@media": {
    [`screen and (min-width: ${breakpoints[1]})`]: {
      fontSize: vars.fontSizes.body.m,
    },
  },
});
